<template>
  <header class="h-16 bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 flex items-center justify-between px-4">
    <!-- Left side -->
    <div class="flex items-center gap-4">
      <button
        @click="$emit('toggle-sidebar')"
        class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400"
      >
        <Menu class="w-5 h-5" />
      </button>
      <h1 v-if="pageTitle" class="text-lg font-semibold text-gray-800 dark:text-gray-200">
        {{ pageTitle }}
      </h1>
    </div>

    <!-- Right side -->
    <div class="flex items-center gap-3">
      <!-- Theme toggle -->
      <button
        @click="appStore.toggleTheme()"
        class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400"
      >
        <Moon v-if="appStore.theme === 'light'" class="w-5 h-5" />
        <Sun v-else class="w-5 h-5 text-yellow-400" />
      </button>

      <!-- Notifications -->
      <button class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400 relative">
        <Bell class="w-5 h-5" />
        <span v-if="notificationCount > 0" class="absolute -top-0.5 -right-0.5 w-4 h-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
          {{ notificationCount > 9 ? '9+' : notificationCount }}
        </span>
      </button>

      <!-- User menu -->
      <div class="flex items-center gap-2 pl-3 border-l border-gray-200 dark:border-gray-700">
        <div class="w-8 h-8 rounded-full bg-primary-100 dark:bg-primary-900 flex items-center justify-center">
          <span class="text-sm font-medium text-primary-700 dark:text-primary-300">
            {{ userInitials }}
          </span>
        </div>
        <div class="hidden sm:block">
          <p class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ authStore.user?.name || 'Admin' }}</p>
          <p class="text-xs text-gray-500 dark:text-gray-400">{{ appStore.appName }}</p>
        </div>
        <button
          @click="handleLogout"
          class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400"
          title="Logout"
        >
          <LogOut class="w-4 h-4" />
        </button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useAppStore } from '@/stores/app'
import { Menu, Moon, Sun, Bell, LogOut } from 'lucide-vue-next'

defineEmits(['toggle-sidebar'])

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const appStore = useAppStore()

const pageTitle = computed(() => route.meta.title || '')
const notificationCount = computed(() => 0)

const userInitials = computed(() => {
  const name = authStore.user?.name || 'Admin'
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
})

function handleLogout() {
  authStore.logout()
  router.push({ name: 'Login' })
}
</script>
